import React from "react";

import { observer } from "mobx-react";
import { Bet } from "@models";
import { useTranslation } from "react-i18next";

export const Payment = observer(function Payment(props: { bet: Bet }) {
	const { t } = useTranslation("mybets");
	const { bet } = props;

	return (
		<div className="bet__details__row u-type--wgt--medium u-color--sent--danger">
			<div className="bet__details__col">{t("REPORTS.PAYMENT")}</div>
			<div className="bet__details__col">{bet.displayPayment}</div>
		</div>
	);
});
